import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=7604b6d9"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=7604b6d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports